<template>
  <el-dialog title="修改密码" :visible.sync="modalShow">
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="120px">
      <el-form-item label="登录密码" prop="password">
        <el-input v-model="form.password" placeholder="登录密码" clearable />
      </el-form-item>
      <el-form-item label="再次确认密码" prop="password2">
        <el-input v-model="form.password2" placeholder="再次确认密码" clearable />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="modalShow = false">取消</el-button>
      <el-button type="primary" size="small" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { resetUserPwd } from "@/api/product/base"

const rules = {
  password: [
    { required: true, message: "请输入手机号", trigger: "blur" },
  ],
  password2: [
    { required: true, message: "请输入手机号", trigger: "blur" },
  ],
}
export default {
  data () {
    return {
      modalShow: false,
      rules,
      form: {
        password: '',
        password2: ''
      }
    }
  },
  methods: {
    init (item) {
      if (!item.id) {
        this.$message.error('参数错误!')
        return
      }
      const defaultData = this.$options.data()
      this.form = defaultData.form
      this.id = item.id
      this.modalShow = true
    },
    async submit () {
      if (this.form.password !== this.form.password2) {
        this.$message.warning('两次输入密码不一致!')
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        const params = {
          id: this.id,
          password: this.form.password
        }
        resetUserPwd(params).then(res => {
          if (res.code === 0) {
            this.$Message.success('密码修改成功')
          }
        }).finally(() => {
          this.modalShow = false
        })
      })
    }
  }
}
</script>

<style>
</style>
